import axios from "axios";
import React from "react";
import { retrieveExpiringSessionData, setExpiringSessionData } from "./SessionStorageHelper";
// import { FE_VERSION } from "../version";
export const getDbHeaders = (token) => {
  return {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
      // "X-App-Version": FE_VERSION,
      // "X-Page-Source": window.location.pathname,
    },
  };
};
const getContentLength = (jsonObject) => {
  const jsonString = JSON.stringify(jsonObject);
  // Encodes the JSON string as UTF-8 and calculates the byte length
  return new TextEncoder().encode(jsonString).length;
};
const updateHeadersWithContentLength = (dbHeaders, data) => {
  const contentLength = getContentLength(data);
  return {
    ...dbHeaders,
    headers: {
      ...dbHeaders.headers,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
};

export function additionalQueryFeatures(query, fieldList, ordering, customOrdering, defaultId, defaultIdName) {
  const queryParts = [];

  if (!query && defaultId && defaultIdName) {
    query = defaultIdName + "=" + defaultId;
  }
  if (query) {
    queryParts.push(query);
  }
  if (fieldList) {
    queryParts.push("fields=" + fieldList);
  }
  if (ordering) {
    queryParts.push("ordering=" + ordering);
  }
  if (customOrdering) {
    queryParts.push("c_ordering=" + customOrdering);
  }

  return queryParts.join("&");
}
export function getAnimoAPIv2({ dbUrl, dbHeaders, apiName, queryParams = {} }) {
  if (!dbUrl || !dbHeaders) {
    return Promise.resolve(null);
  }
  return axios
    .get(
      // ensure the URL ends up as `${dbUrl}/apiName/?key=val&…`
      // add the trailing slash if your backend expects it
      `${dbUrl.replace(/\/$/, "")}/${apiName}/`,
      {
        ...dbHeaders,
        params: queryParams,
      }
    )
    .then((res) => res.data)
    .catch((err) => {
      // bubble errors back into React-Query
      throw err;
    });
}
/**
 * Write counterpart to getAnimoAPIv2 — POST, PATCH, PUT or DELETE.
 *
 * Same contract as the v2 read helper: errors are re-thrown rather than resolved, so React Query
 * and any caller with a try/catch can actually see a failure. The older helpers in this file
 * resolve with the error object, which makes a failed write indistinguishable from a successful
 * one that returned nothing.
 *
 * @param {"POST"|"PATCH"|"PUT"|"DELETE"} [method="POST"]
 */
export function writeAnimoAPIv2({ dbUrl, dbHeaders, apiName, method = "POST", body = {}, queryParams = {} }) {
  if (!dbUrl || !dbHeaders) {
    return Promise.resolve(null);
  }
  const url = `${dbUrl.replace(/\/$/, "")}/${apiName}/`;
  const config = { ...dbHeaders, params: queryParams };

  const request =
    method === "DELETE"
      ? axios.delete(url, config)
      : axios[method.toLowerCase()](url, body, config);

  return request
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function getAnimoAPI(dbUrl, dbHeaders, apiName, query, fieldList, ordering, customOrdering, defaultId, defaultIdName) {
  return new Promise((resolve) => {
    query = additionalQueryFeatures(query, fieldList, ordering, customOrdering, defaultId, defaultIdName);
    const url = query ? dbUrl + `${apiName}/?${query}` : dbUrl + `${apiName}/`;
    axios
      .get(url, dbHeaders)
      .then((res) => {
        if (res && res.data) {
          resolve(res.data);
        } else resolve(null);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}

export function getAnimoAPIToSelect(dbUrl, dbHeaders, apiName, query, fieldList, ordering, customOrdering, defaultId, defaultIdName, valueProp, labelProp) {
  return new Promise((resolve) => {
    query = additionalQueryFeatures(query, fieldList, ordering, customOrdering, defaultId, defaultIdName);
    const url = query ? dbUrl + `${apiName}/?${query}` : dbUrl + `${apiName}/`;
    axios
      .get(url, dbHeaders)
      .then((res) => {
        if (res.data && res.data.length) {
          res.data.forEach((element) => {
            element.value = element[valueProp ? valueProp : "id"];
            element.label = element[labelProp ? labelProp : "name"];
          });
          resolve(res.data);
        } else resolve(null);
      })
      .catch((error) => {
        console.log("Error", error);
        resolve(error);
      });
  });
}

export function getSingleEntry(dbUrl, dbHeaders, apiName, entry, fieldList) {
  return new Promise((resolve) => {
    let fields = "";
    if (entry && fieldList) {
      fields = "?fields=" + fieldList;
    }
    if (entry) {
      axios
        .get(dbUrl + `${apiName}/${entry}/${fields}`, dbHeaders)
        .then((res) => {
          if (res && res.data) {
            resolve(res.data);
          } else resolve(null);
        })
        .catch((error) => {
          resolve(error);
        });
    } else resolve(null);
  });
}

export function patchEntry(dbUrl, dbHeaders, apiName, entryId, entryObject, isIdReturned) {
  const updatedHeaders = updateHeadersWithContentLength(dbHeaders, entryObject);
  console.log("Do we reutrn all res.data?", isIdReturned);
  return new Promise((resolve) => {
    axios
      .patch(dbUrl + `${apiName}/${entryId}/`, entryObject, updatedHeaders)
      .then((res) => {
        if (res && res.data) {
          console.log("here is res.data", res.data);
          if (isIdReturned) {
            resolve(res.data.id);
          } else resolve(res.data);
        } else resolve(null);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}

export function postEntry(dbUrl, dbHeaders, apiName, entryObject, isIdReturned) {
  const updatedHeaders = updateHeadersWithContentLength(dbHeaders, entryObject);
  return new Promise((resolve) => {
    axios.post(dbUrl + `${apiName}/`, entryObject, updatedHeaders).then((res) => {
      if (res && res.data) {
        if (isIdReturned) {
          resolve(res.data.id);
        } else resolve(res.data);
      } else resolve(null);
    });
    // .catch((error) => {
    //   throw error;
    //   // resolve(error);
    // });
  });
}
export function postEntryErrorLogger(dbUrl, dbHeaders, apiName, entryObject, isIdReturned) {
  const updatedHeaders = updateHeadersWithContentLength(dbHeaders, entryObject);
  return new Promise((resolve) => {
    axios
      .post(dbUrl + `${apiName}/`, entryObject, updatedHeaders)
      .then((res) => {
        if (res && res.data) {
          if (isIdReturned) {
            resolve(res.data.id);
          } else resolve(res.data);
        } else resolve(null);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}
export function postFileEntry(dbUrl, dbHeaders, apiName, entryObject, isIdReturned) {
  return new Promise((resolve) => {
    axios.post(dbUrl + `${apiName}/`, entryObject, dbHeaders).then((res) => {
      if (res && res.data) {
        if (isIdReturned) {
          resolve(res.data.id);
        } else resolve(res.data);
      } else resolve(null);
    });
    // .catch((error) => {
    //   throw error;
    //   // resolve(error);
    // });
  });
}
export function putEntry(dbUrl, dbHeaders, apiName, entryObject, isIdReturned) {
  const updatedHeaders = updateHeadersWithContentLength(dbHeaders, entryObject);
  return new Promise((resolve) => {
    axios.put(dbUrl + `${apiName}/`, entryObject, updatedHeaders).then((res) => {
      if (res && res.data) {
        if (isIdReturned) {
          resolve(res.data.id);
        } else resolve(res.data);
      } else resolve(null);
    });
    // .catch((error) => {
    //   throw error;
    //   // resolve(error);
    // });
  });
}

export function deleteEntry(dbUrl, dbHeaders, apiName, entryId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(dbUrl + `${apiName}/${entryId}/`, dbHeaders)
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function postExternalEntry(dbUrl, apiName, entryObject, isIdReturned) {
  return new Promise((resolve) => {
    axios
      .post(dbUrl + `${apiName}/`, entryObject)
      .then((res) => {
        if (res && res.data) {
          if (isIdReturned) {
            resolve(res.data.id);
          } else resolve(res.data);
        } else resolve(null);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}

export const retrieveAppSubscriptions = async (dbUrl, dbHeaders, userId, operatorId, getPartnerDefault, appType = "dock") => {
  let apiName = getPartnerDefault ? "partner-app-subscriptions" : "person-app-subscriptions";
  let query = `app_type=${appType}`;
  if (getPartnerDefault) {
    query = query + "&is_active=True&partner=" + operatorId;
  } else {
    query = query + "&user=" + userId;
  }
  let fieldList = "app_name"; //'id,person,app_feature,app_label,app_icon,app_type,app_size,app_purpose,app_name,app_description'
  let ordering = "app_order";
  let appList = await getAnimoAPI(dbUrl, dbHeaders, apiName, query, fieldList, ordering, null, operatorId, "partner");
  if (Array.isArray(appList)) return appList;
  if (Array.isArray(appList?.results)) return appList.results;
  return [];
};
export const getSafeAPIReturn = async ({ dbUrl, dbHeaders, apiName, query, fieldList, ordering }) => {
  let result = await getAnimoAPI(dbUrl, dbHeaders, apiName, query, fieldList, ordering);
  return result || [];
};
export const retrieveAllAppSubscriptions = async (dbUrl, dbHeaders, userId, operatorId, appType = "dock", fieldList) => {
  const sessionKey = `appSubs_${appType}_${userId}_${operatorId}`;
  // 60-minute expiration -- retrieveExpiringSessionData ignores stale entries and
  // returns null once older than this, so callers naturally refetch about hourly.
  let cachedAppList = retrieveExpiringSessionData(sessionKey, 60);

  if (cachedAppList && cachedAppList.length) {
    return cachedAppList;
  }
  let query = `app_type=${appType}`;
  let defaultFieldList = fieldList ? fieldList : "app_name"; // Adjust this as needed
  let ordering = "app_order";

  // Fetch partner app subscriptions
  let partnerQuery = query + `&is_active=True&partner=${operatorId}`;
  let partnerAppList = await getAnimoAPI(dbUrl, dbHeaders, "partner-app-subscriptions", partnerQuery, defaultFieldList, ordering, null, operatorId, "partner");

  // Fetch person app subscriptions
  let personQuery = query + `&active=True&user=${userId}`;
  let personAppList = await getAnimoAPI(dbUrl, dbHeaders, "person-app-subscriptions", personQuery, defaultFieldList, ordering, null, operatorId, "partner");

  // Combine both app lists
  let combinedAppList = [...(partnerAppList || []), ...(personAppList || [])];

  // Remove duplicates based on 'app_name' (or another unique identifier if needed)
  let uniqueAppList = combinedAppList.reduce((acc, current) => {
    if (!acc.find((app) => app.app_name === current.app_name)) {
      acc.push(current);
    }
    return acc;
  }, []);
  setExpiringSessionData(sessionKey, uniqueAppList);

  // Return the unique app list
  return uniqueAppList;
};
export const getKPISegment = async({dbUrl, dbHeaders, apiName, query, fieldList,ordering }) => {
    let result = await getAnimoAPI(dbUrl, dbHeaders, apiName, query, fieldList, ordering);
    return result || []
}

export const fetchAppSubscriptions = async (dbUrl, dbHeaders, userId, operatorId, appType = "dock") => {
  const query = `app_type=${appType}`;
  const fieldList = "app_name";
  const ordering = "app_order";

  const partnerQuery = `${query}&is_active=True&partner=${operatorId}`;
  const personQuery = `${query}&active=True&user=${userId}`;

  const [partnerAppList, personAppList] = await Promise.all([
    getAnimoAPI(dbUrl, dbHeaders, "partner-app-subscriptions", partnerQuery, fieldList, ordering, null, operatorId, "partner"),
    getAnimoAPI(dbUrl, dbHeaders, "person-app-subscriptions", personQuery, fieldList, ordering, null, operatorId, "partner"),
  ]);

  const combinedAppList = [...(partnerAppList || []), ...(personAppList || [])];

  const uniqueAppList = combinedAppList.reduce((acc, current) => {
    if (!acc.find((app) => app.app_name === current.app_name)) {
      acc.push(current);
    }
    return acc;
  }, []);

  return uniqueAppList;
};

export const getCachedAppSubscriptions = async (dbUrl, dbHeaders, userId, operatorId, appType = "dock", forceRefresh = false) => {
  const sessionKey = `appSubs_${appType}_${userId}_${operatorId}`;

  if (!forceRefresh) {
    // 60-minute expiration -- matches the TTL callers expect ("refresh about hourly").
    const cached = retrieveExpiringSessionData(sessionKey, 60);
    if (cached && cached.length) {
      return cached;
    }
  }

  const fresh = await fetchAppSubscriptions(dbUrl, dbHeaders, userId, operatorId, appType);
  setExpiringSessionData(sessionKey, fresh);
  return fresh;
};
